import { Factory } from 'miragejs';

export default Factory.extend({
  locationId: 1,
  hasRequiredDocumentApproval: true,
  requiredDocumentApprovalExpiresAt: null,
  requiredDocumentMessage: null,
});
